import { Card, CardHeader, CardContent, Stack, TextField, CardActions, Typography, Modal } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { updateBranch } from '../store/branchActions';

const branchSchema = yup.object({
  name: yup.string().required('Branch name is required'),
  location_code: yup.string().required('Location code is required'),
});

CustomerEditForm.propTypes = {
  showCustomerEditModal: PropTypes.bool,
  showCustomerEditModalHandler: PropTypes.func,
  customer: PropTypes.object,
};

export default function CustomerEditForm({ customer, showCustomerEditModal, showCustomerEditModalHandler }) {
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.branchReducer);

  useEffect(() => {
    if (isSuccess) {
      showCustomerEditModalHandler();
    }
  }, [isSuccess, showCustomerEditModalHandler]);

  const onSubmit = (values) => {
    dispatch(updateBranch({ id: customer.id, payload: values }));
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: {
      name: customer.name || '',
      location_code: customer.location_code || '',
    },
    validationSchema: branchSchema,
    onSubmit,
  });

  return (
    <Modal
      open={showCustomerEditModal}
      onClose={showCustomerEditModalHandler}
      aria-labelledby="edit-branch-title"
    >
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', md: '500px' },
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
        }}
      >
        <form onSubmit={handleSubmit}>
          <CardHeader id="edit-branch-title" title="Edit Branch" />
          <CardContent>
            <Stack spacing={2}>
              <TextField
                name="name"
                type="text"
                label="Branch Name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.name && Boolean(errors.name)}
              />
              {touched.name && Boolean(errors.name) && (
                <Typography color="error" variant="body2">
                  {errors.name}
                </Typography>
              )}
              <TextField
                name="location_code"
                type="text"
                label="Location Code"
                value={values.location_code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.location_code && Boolean(errors.location_code)}
              />
              {touched.location_code && Boolean(errors.location_code) && (
                <Typography color="error" variant="body2">
                  {errors.location_code}
                </Typography>
              )}
            </Stack>
          </CardContent>
          <CardActions>
            <LoadingButton color="error" variant="contained" onClick={showCustomerEditModalHandler}>
              Cancel
            </LoadingButton>
            <LoadingButton loading={isLoading} type="submit" variant="contained">
              Submit
            </LoadingButton>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}
